import { Component } from '@angular/core';

@Component({
  selector: 'app-manage-zones-page',
  templateUrl: './manage-zones-page.component.html',
  styleUrls: ['./manage-zones-page.component.scss'],
})
export class ManageZonesPageComponent {
}
